export type Language = "ru" | "en";

export const TRANSLATIONS = {
  en: {
    invitation: "Invitation",
    locationAndDates: "Location & Dates",
    thePlan: "The Plan",
    theCouple: "The Couple",
    guestList: "Guest Database",
    contacts: "Contacts",
    weddingProtocol: "Kemer, Antalya — 16.05.2026",
    scrollToInitialize: "SCROLL TO INITIALIZE",
    viewFullIntel: "View Full Intel",
    dates: "Dates",
    location: "Location",
    howToGetThere: "How to get there",
    beforeTheWedding: "Before the Wedding",
    weddingDay: "Wedding Day",
    afterTheWedding: "After the Wedding",
    guestDatabase: "GUEST DATABASE",
    guestStats: "GUEST DATABASE",
    countries: "COUNTRIES",
    languages: "LANGUAGES",
    authorizedAccess: "AUTHORIZED ACCESS ONLY",
    guests: "GUESTS",
    adults: "ADULTS",
    children: "CHILDREN",
    with: "WITH",
    names: "NAMES",
    lang: "LANG",
    origin: "LOCATION",
    back: "BACK",
    tMinus: "T-MINUS",
    days: "DAYS",
    date: "DATE",
    mainProtocol: "MAIN PROTOCOL",
    externalIntel: "EXTERNAL INTEL",
    systemOnline: "SYSTEM ONLINE",
    selectLanguage: "SELECT LANGUAGE",
    russian: "Русский",
    english: "English",
    beforeTheWeddingTitle: "Before the Wedding",
    beforeTheWeddingDate: "14.05 — 15.05",
    beforeTheWeddingDesc:
      "We'll be arriving early and moving to Mirada Del Mar Hotel on May 14th. You're welcome to arrive whenever you like! We'd love to spend time with you, though our availability will depend on the final official preparations.",
    theWeddingTitle: "The Wedding",
    theWeddingDate: "16.05",
    theWeddingDesc:
      "We'll head to Antalya from the hotel for the official ceremony (Time & Location TBD). Afterwards, we'll all travel together to the banquet (Location TBD) to celebrate until the end.",
    afterTheWeddingTitle: "After the Wedding",
    afterTheWeddingDate: "17.05 — 21.05",
    afterTheWeddingDesc:
      "We'll be staying at the hotel with our families. We'd love to spend some spontaneous quality time with all of our guests during these days!",
    capturedMoments: "Captured moments from our journey.",
    openGallery: "Open Gallery",
    secureChannels: "Secure communication channels.",
    groupChat: "Guest Group Chat",
    joinChat: "JOIN CHANNEL",
    officialPart: "Official Part",
    officialPartDesc: "Antalya City",
    banquet: "Banquet",
    banquetDesc: "Kemer, Antalya",
    hotel: "Accommodation",
    hotelDesc: "Mirada Del Mar Hotel",
    hotelNote:
      "This is where we'll be staying. Guests are kindly requested to arrange their own accommodation nearby.",
    locationsTBD: "Exact locations to be defined",
    googleMaps: "Google Maps",
    additionalIntel: "ADDITIONAL INTEL",
    subjectDesignation: "SUBJECT DESIGNATION",
    langNames: {
      Russian: "Russian",
      English: "English",
      French: "French",
      Arabic: "Arabic",
      Dutch: "Dutch",
    },
  },
  ru: {
    invitation: "Приглашение",
    locationAndDates: "Место и Даты",
    thePlan: "Программа",
    theCouple: "Мы",
    guestList: "База данных гостей",
    contacts: "Контакты",
    weddingProtocol: "Кемер, Анталья — 16.05.2026",
    scrollToInitialize: "ПРОКРУТИТЕ ДЛЯ ЗАПУСКА",
    viewFullIntel: "Открыть досье",
    dates: "Даты",
    location: "Место",
    howToGetThere: "Как добраться",
    beforeTheWedding: "Перед свадьбой",
    weddingDay: "День свадьбы",
    afterTheWedding: "После свадьбы",
    guestDatabase: "БАЗА ДАННЫХ ГОСТЕЙ",
    guestStats: "БАЗА ДАННЫХ ГОСТЕЙ",
    countries: "СТРАНЫ",
    languages: "ЯЗЫКИ",
    authorizedAccess: "ДОСТУП ТОЛЬКО ДЛЯ АВТОРИЗОВАННЫХ ЛИЦ",
    guests: "ГОСТЕЙ",
    adults: "ВЗРОСЛЫХ",
    children: "ДЕТИ",
    with: "С",
    names: "ИМЕНА",
    lang: "ЯЗЫК",
    origin: "ЛОКАЦИЯ",
    back: "НАЗАД",
    tMinus: "T-МИНУС",
    days: "ДНЕЙ",
    date: "ДАТА",
    mainProtocol: "ОСНОВНОЙ ПРОТОКОЛ",
    externalIntel: "ВНЕШНИЕ ДАННЫЕ",
    systemOnline: "СИСТЕМА АКТИВНА",
    selectLanguage: "ВЫБЕРИТЕ ЯЗЫК",
    russian: "Русский",
    english: "English",
    beforeTheWeddingTitle: "Перед свадьбой",
    beforeTheWeddingDate: "14.05 — 15.05",
    beforeTheWeddingDesc:
      "Мы приедем заранее и заселимся в отель Mirada Del Mar 14 мая. Вы можете приехать в любое удобное для вас время! Мы будем рады провести с вами время, хотя наша доступность будет зависеть от финальных официальных приготовлений.",
    theWeddingTitle: "Свадьба",
    theWeddingDate: "16.05",
    theWeddingDesc:
      "Мы отправимся в Анталью из отеля на официальную церемонию (время и место уточняются). После этого мы все вместе отправимся на банкет (место уточняется), чтобы праздновать до самого конца.",
    afterTheWeddingTitle: "После свадьбы",
    afterTheWeddingDate: "17.05 — 21.05",
    afterTheWeddingDesc:
      "Мы останемся в отеле вместе с нашими семьями. Будем рады провести время с нашими гостями в свободном формате в эти дни!",
    capturedMoments: "Запечатленные моменты нашего пути.",
    openGallery: "Открыть галерею",
    secureChannels: "Защищенные каналы связи.",
    groupChat: "Чат для гостей",
    joinChat: "ВСТУПИТЬ В КАНАЛ",
    officialPart: "Официальная часть",
    officialPartDesc: "Анталья",
    banquet: "Праздничный ужин",
    banquetDesc: "Кемер, Анталья",
    hotel: "Проживание",
    hotelDesc: "Mirada Del Mar Hotel",
    hotelNote:
      "Здесь будем жить мы. Гостям необходимо самостоятельно позаботиться о проживании поблизости.",
    locationsTBD: "Точные локации будут определены позже",
    googleMaps: "Google Карты",
    additionalIntel: "ДОПОЛНИТЕЛЬНЫЕ ДАННЫЕ",
    subjectDesignation: "ОБОЗНАЧЕНИЕ ОБЪЕКТА",
    langNames: {
      Russian: "Русский",
      English: "Английский",
      French: "Французский",
      Arabic: "Арабский",
      Dutch: "Голландский",
    },
  },
};
